import { render, staticRenderFns } from "./LivestreamIframePrivacyPolicy.vue?vue&type=template&id=0ce39c79&scoped=true"
import script from "./LivestreamIframePrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LivestreamIframePrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce39c79",
  null
  
)

export default component.exports